import PropertyActions from "./PropertyActions";

export default PropertyActions;